import { render } from "./MessageBubble.vue?vue&type=template&id=7bdeff96&scoped=true"
import script from "./MessageBubble.vue?vue&type=script&lang=js"
export * from "./MessageBubble.vue?vue&type=script&lang=js"

import "./MessageBubble.vue?vue&type=style&index=0&id=7bdeff96&lang=scss&scoped=true"
import "./MessageBubble.vue?vue&type=style&index=1&id=7bdeff96&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bdeff96"]])

export default __exports__